import React from 'react';
import { ShoppingCart, Loader2 } from 'lucide-react';
import CheckoutReviewBadge from '../CheckoutReviewBadge';
import ConversionUSPBar from '../ConversionUSPBar';
import AnnualFuelCostCard from '../shared/AnnualFuelCostCard';
import { FleetInquiryForm } from './FleetInquiryForm';

/** Schritt 3: Dunkler „Dein Deal"-Block mit Total, Checkout-CTA + Conversion-USPs. */
export const ConfiguratorTotal = ({
  heroTotalRef, result, isPvt, cardName, vehicles, annualKm,
  totalAmount, loading, fmt, onCheckout, hideAvatar = false,
  mode = 'private', householdVehicles = 1,
}) => (
  <>
    <div ref={heroTotalRef} className="rounded-2xl bg-stone-950 text-white p-5 sm:p-6 mb-5" data-testid="configurator-hero-total">
      <p className="text-[10px] font-medium uppercase tracking-[0.2em] text-stone-500 mb-3.5">3 · Dein Deal</p>
      <div className="mb-5">
        <p className="text-[10px] text-stone-500 mb-1.5">Dein Preis · inkl. MwSt.</p>
        <p className="text-3xl sm:text-4xl lg:text-5xl font-display leading-none tracking-tight tabular-nums text-white whitespace-nowrap" data-testid="configurator-total-display">
          {result ? fmt(totalAmount) : '—'} €
        </p>
        <p className="text-[10px] text-stone-500 leading-tight mt-2">
          {isPvt ? `${cardName} / Jahr` : `${vehicles} × 49,90 € / Jahr`}
        </p>
      </div>

      {/* Trust-Pills direkt über dem CTA — Reibung senken, Konversion steigern */}
      <div className="mb-3.5">
        <ConversionUSPBar variant="pills" dark testId="configurator-trust-pills" />
      </div>

      {result?.requires_inquiry ? (
        <FleetInquiryForm vehicles={vehicles} annualKm={annualKm} />
      ) : (
        <button
          onClick={onCheckout}
          disabled={loading || !result}
          className={`w-full flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 px-4 sm:px-6 py-4 rounded-full text-sm font-semibold transition duration-200 hover:-translate-y-0.5 ${
            isPvt
              ? 'bg-emerald-500 text-white hover:bg-emerald-400 shadow-lg shadow-emerald-500/30'
              : 'bg-yellow-400 text-stone-900 hover:bg-yellow-300 shadow-lg shadow-yellow-400/25'
          } disabled:opacity-60 disabled:hover:translate-y-0`}
          data-testid="configurator-checkout-btn"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin flex-shrink-0" strokeWidth={2} /> : <ShoppingCart className="w-4 h-4 flex-shrink-0" strokeWidth={2} />}
          <span className="whitespace-nowrap">In den Warenkorb</span>
          <span className="whitespace-nowrap tabular-nums">— {result ? fmt(totalAmount) : '0,00'} €</span>
        </button>
      )}

      <div className="mt-4 pt-4 border-t border-white/10">
        <CheckoutReviewBadge dark variant={isPvt ? 'private' : 'business'} hideAvatar={hideAvatar} testId="configurator-checkout-reviews" />
      </div>
    </div>

    {/* Spritkosten-Kachel — direkt über dem Value-Stack */}
    <div className="mb-5">
      <AnnualFuelCostCard
        mode={mode}
        vehicleCount={isPvt ? householdVehicles : vehicles}
        annualKm={annualKm}
        testId="configurator-fuel-cost"
      />
    </div>

    {/* Value-Stack — was in der Card steckt (modernes Conversion-Modul) */}
    {result && (
      <div className="mb-6" data-testid="configurator-result">
        <ConversionUSPBar variant="valuestack" testId="configurator-value-stack" />
      </div>
    )}
  </>
);
